import { AccountDetailsLayout } from "@common/Layout/AccountDetailsLayout";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { Grid } from "@material-ui/core";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import ManageNuisanceCall from "./ManageNuisanceCall";
import ManageServices from "./ManageServices";

const ManageMobileServicesPage = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const { t } = useTranslation("accountDetails");

    return (
        <AccountDetailsLayout requireNumberSelection title={t("manageMobileServices")}>
            {selectedService && (
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <ManageServices selectedService={selectedService} />
                    </Grid>
                    <Grid item xs={12}>
                        <ManageNuisanceCall selectedService={selectedService} />
                    </Grid>
                </Grid>
            )}
        </AccountDetailsLayout>
    );
};

export default ManageMobileServicesPage;
